import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "urlControl", "stepParamName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useContext } from 'react';
import { Wizard } from 'react-use-wizard';
import useWizardLogic from './wizard.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var WizardContext = /*#__PURE__*/createContext(null);
export var WizardProvider = function WizardProvider(_ref) {
  var children = _ref.children,
      urlControl = _ref.urlControl,
      stepParamName = _ref.stepParamName,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Wizard, _objectSpread(_objectSpread({}, rest), {}, {
    children: children === null || children === void 0 ? void 0 : children.map(function (child, index) {
      return /*#__PURE__*/_jsx(WizardEnrichmentProvider, {
        urlControl: urlControl,
        stepParamName: stepParamName,
        children: child
      }, index);
    })
  }));
};

var WizardEnrichmentProvider = function WizardEnrichmentProvider(_ref2) {
  var children = _ref2.children,
      urlControl = _ref2.urlControl,
      _ref2$stepParamName = _ref2.stepParamName,
      stepParamName = _ref2$stepParamName === void 0 ? 'step' : _ref2$stepParamName;

  var _useWizardLogic = useWizardLogic({
    urlControl: urlControl,
    stepParamName: stepParamName
  }),
      value = _useWizardLogic.value;

  return /*#__PURE__*/_jsx(WizardContext.Provider, {
    value: value,
    children: children
  });
};

export var useWizard = function useWizard() {
  var context = useContext(WizardContext);
  if (context === null) throw new Error('useWizard must be used within a WizardProvider');
  return context;
};